import React, { useEffect, useState } from 'react';

interface Props {
  open: boolean;
  onClose: () => void;
  embedUrl: string;
}

export const VideoModal = (props: Props) => {
  const { open, onClose, embedUrl } = props;

  const [src, setSrc] = useState('');

  useEffect(() => {
    if (open && embedUrl) {
      try {
        const u = new URL(embedUrl);
        const host = u.host.toLowerCase();
        if (host.includes('youtube.com') || host.includes('youtu.be')) {
          if (!u.searchParams.has('rel')) u.searchParams.set('rel', '0');
          if (!u.searchParams.has('showinfo')) u.searchParams.set('showinfo', '0');
          if (!u.searchParams.has('enablejsapi')) u.searchParams.set('enablejsapi', '1');
          if (!u.searchParams.has('origin') && typeof window !== 'undefined') {
            u.searchParams.set('origin', window.location.origin);
          }
        }
        setSrc(u.toString());
      } catch {
        setSrc(embedUrl);
      }
    } else {
      setSrc('');
    }
  }, [open, embedUrl]);

  if (!embedUrl) return null;
  return open ? (
    <div
      className="adage-modal-wrapper generic-gallery-container active"
      id="generic-gallery"
      role="button"
      aria-label="Close video modal"
      tabIndex={0}
      onClick={(e) => {
        if (e.currentTarget === e.target) onClose();
      }}
      onKeyDown={(e) => {
        if (e.key === 'Escape' || e.key === 'Enter' || e.key === ' ') onClose();
      }}
    >
      <div
        className="adage-modal-dialog"
        role="dialog"
        aria-modal="true"
        aria-label="Video modal"
      >
        <div className="generic-gallery-upper">
          <button
            id="generic-gallery-close"
            className="adage-modal-close"
            type="button"
            aria-label="Close"
            onClick={onClose}
          ></button>
        </div>
        <div className="adage-modal-inner">
          <div className="adage-video-iframe video-content">
            <iframe
              id="generic-gallery-content"
              src={src}
              allowFullScreen
              title="Video player"
            />
          </div>
        </div>
      </div>
    </div>
  ) : null;
};
